import * as XLSX from "xlsx";

export function downloadTable(filename, columns, rows) {
	const header = columns.map((col) => col.label);
	const body = rows.map((row) =>
		columns.map((col) => {
			const value = row[col.key];
			if (value === null || value === undefined) return "";
			return value;
		})
	);
	const sheet = XLSX.utils.aoa_to_sheet([header, ...body]);
	const book = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(book, sheet, "Data");
	XLSX.writeFile(book, filename.endsWith(".xlsx") ? filename : `${filename}.xlsx`);
}
